export default __webpack_public_path__ + "static/media/logo.aa786053.png";